/**
 * 登录/注册后回跳目标的暂存工具（v2.0.48）
 *
 * 场景：用户在公开页（如利润自测 /profit-quiz）做完测试后需要注册才能看完整诊断，
 * 注册流程要经过「提交注册 → 邮箱验证链接 → 回到登录页 → 登录」，
 * 中途会离开 SPA，sessionStorage 不一定可靠，因此用 localStorage + 24 小时有效期兜底。
 */

const KEY = 'ibusiness:postAuthRedirect';
const TTL_MS = 24 * 60 * 60 * 1000; // 24 小时

/** 仅允许站内相对路径，避免开放重定向 */
function isSafePath(path: string): boolean {
  return typeof path === 'string' && path.startsWith('/') && !path.startsWith('//');
}

export function setPostAuthRedirect(path: string): void {
  if (!isSafePath(path)) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, ts: Date.now() }));
  } catch {
    /* 隐私模式等场景写入失败，忽略 */
  }
}

/** 读取并清除回跳目标；无有效值时返回 null */
export function consumePostAuthRedirect(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const parsed = JSON.parse(raw) as { path?: string; ts?: number };
    const path = parsed && parsed.path ? parsed.path : '';
    const ts = parsed && parsed.ts ? parsed.ts : 0;
    if (!isSafePath(path)) return null;
    if (!ts || Date.now() - ts > TTL_MS) return null;
    return path;
  } catch {
    return null;
  }
}

export function clearPostAuthRedirect(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
